export default function TrustBar() {
  const badges = [
    { icon: 'ri-map-pin-line', text: 'Empresa local Barcelona' },
    { icon: 'ri-shield-check-line', text: 'Protocolos de seguridad' },
    { icon: 'ri-file-text-line', text: 'Presupuesto sin compromiso' },
    { icon: 'ri-handshake-line', text: 'Coordinación con seguros' },
  ];

  return (
    <section className="bg-bg py-8 border-y border-gray-200 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 lg:gap-8">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="bg-white px-4 sm:px-6 py-3 rounded-full shadow-sm flex items-center space-x-2 whitespace-nowrap"
            >
              <i className={`${badge.icon} text-secondary text-base sm:text-lg`}></i>
              <span className="text-xs sm:text-sm font-sans font-medium text-primary">✓ {badge.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}